import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import DarkModeToggle from "./components/DarkModeToggle";
import SchoolPage from "./pages/SchoolPage";
import ClubPage from "./pages/ClubPage";
import DonatePage from "./pages/DonatePage";
import LoginPage from "./pages/LoginPage";
import TeacherDashboard from "./pages/TeacherDashboard";
import "./styles/App.css"; // atau whatever your global CSS is

function InnerApp() {
  const location = useLocation();
  const isDashboard = location.pathname.startsWith("/dashboard");

  return (
    <>
      {!isDashboard && <DarkModeToggle />}
      <Routes>
        <Route path="/" element={<Navigate to="/sktpp2/robotik" />} />
        <Route path="/:schoolShortName" element={<SchoolPage />} />
        <Route path="/:schoolShortName/:clubName" element={<ClubPage />} />
        <Route path="/:schoolShortName/fundraiser/:fundraiserId" element={<DonatePage />} />

        {/* Auth routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<TeacherDashboard />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <div className="app">
        <InnerApp />
      </div>
    </Router>
  );
}
